export const SET_USER_COMMUNITIES = `communities/SET_USER_COMMUNITIES`;
export const REMOVE_USER_COMMUNITY = `communities/REMOVE_USER_COMMUNITY`;

